import type { ReactNode } from 'react';

/** A player's name inside a sentence: bold and coloured so it stands out. */
export function PName({ children }: { children: ReactNode }) {
  return <strong className="pname">{children}</strong>;
}

const escape = (s: string) => s.replace(/[.*+?^${}()|[\]\\]/g, (c) => `\\${c}`);

/** Text with every occurrence of a player's name picked out as a `PName`. Rendered as text, never HTML. */
export function Highlight({ text, names }: { text: string; names: readonly (string | undefined)[] }) {
  const list = [...new Set(names.filter((n): n is string => !!n))].sort((a, b) => b.length - a.length);
  if (list.length === 0) return <>{text}</>;
  const parts = text.split(new RegExp(`(${list.map(escape).join('|')})`));
  return <>{parts.map((part, i) => (i % 2 === 1 ? <PName key={i}>{part}</PName> : part))}</>;
}
